// Get weapon-specific targeting messages for deploy effects (i18n keys under battleUI)

import i18n from '../i18n';

const WEAPON_TARGETING_KEYS = {
  119: 'battleUI.weaponTargetingConfuseGrenade', // Toxic Shroud Grenade
  333: 'battleUI.weaponTargetingImmobilizeBlaster', // Tranquilizer Blaster
};

/**
 * Get the targeting message for a specific weapon
 * @param {number|null|undefined} weaponId - The weapon ID
 * @returns {string} - The weapon-specific message or a generic fallback
 */
function getWeaponTargetingMessage(weaponId) {
  const key = weaponId != null ? WEAPON_TARGETING_KEYS[Number(weaponId)] : undefined;
  if (key) {
    return i18n.t(key);
  }
  return i18n.t('battleUI.weaponTargetingGeneric');
}

export default getWeaponTargetingMessage;

